export const cleanEmpties = (iarr) => {
    const rarr = [];
    for ( let i = 0; i < iarr.length; i ++ ) {
        if (iarr[i] !== "") {
            rarr.push(iarr[i]);
        }
    }
    return rarr;
}

export const getSelected = (pathname, firstorlast = "last") => {
    let npath = "";
    const patharr = cleanEmpties(pathname.split("/"));
    if(firstorlast === "last") {
        npath = patharr[patharr.length - 1];
    } 
    if(firstorlast === "first") {
        npath = patharr[0];
    }
    return npath;
}